import getApolloClient from '../../app/apollo/getApolloClient';
import { gql } from '../../graphql/generated/gql';
import getFeature from '../features';

const limit = getFeature('attachment_size_limit');

export const overlargeImageMessage = limit
  ? `Image exceeded the maximum upload size of ${limit}MB.`
  : 'Image exceeded the maximum upload size.';

const UPLOAD_POST_IMAGE_MUTATION = gql(`
  mutation uploadPostImage($file: Upload, $url: String) {
    image: uploadPostImage(file: $file, url: $url) {
      url
    }
  }
`);

export default async function uploadPostImage(source: File | string) {
  const client = await getApolloClient();
  const key = source instanceof File ? 'file' : 'url';
  const { data } = await client.mutate({
    mutation: UPLOAD_POST_IMAGE_MUTATION,
    variables: { [key]: source },
  });
  return data?.image.url ?? null;
}
